module.exports = __webpack_public_path__ + "bitcoin-buyBlue.svg?d04c52b29644d80b9069495db4da5a41";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/bitcoin-buyBlue.svg
// module id = 834
// module chunks = 2